export class DateRange {
    zeit_von: Date;
    zeit_bis: Date;
}
